import { createSlice, createAction } from '@reduxjs/toolkit';

import { defaultValues as initialShopper } from 'pages/Checkout/components/ShopperDetailsForm.schema';
import { defaultValues as initialShipping } from 'pages/Checkout/components/ShippingDetailsForm.schema';
import { defaultValues as initialBilling, FIELD_NAMES } from 'pages/Checkout/components/BillingAddress/BillingAddress.schema';

import { cleanCart } from '../cart';
import {
  CHECKOUT,
  SAVE_BILLING_ADDRESS,
  SAVE_SHIPPING_DETAILS,
  SAVE_SHOPPER_DETAILS,
  SET_BILLING_ADDRESS_SAME_AS_SHIPPING,
} from './types';

export const initialState = {
  shopperDetails: initialShopper,
  shippingDetails: initialShipping,
  billingAddress: initialBilling,
};

export const saveShopperDetails = createAction(SAVE_SHOPPER_DETAILS);
export const saveShippingDetails = createAction(SAVE_SHIPPING_DETAILS);
export const saveBillingAddress = createAction(SAVE_BILLING_ADDRESS);
export const setBillingAddressSameAsShipping = createAction(SET_BILLING_ADDRESS_SAME_AS_SHIPPING);

const checkoutForm = createSlice({
  name: CHECKOUT,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(cleanCart.fulfilled, (state) => {
        return (state = initialState);
      })
      .addCase(saveShopperDetails, (state, { payload }) => {
        state.shopperDetails = payload;
      })
      .addCase(saveShippingDetails, (state, { payload }) => {
        state.shippingDetails = payload;
      })
      .addCase(saveBillingAddress, (state, { payload }) => {
        state.billingAddress = payload;
      })
      .addCase(setBillingAddressSameAsShipping, (state, { payload }) => {
        state.billingAddress[FIELD_NAMES.billingAddressSameAsShipping] = payload;
      })
  },
});

export default checkoutForm.reducer;
